/*
 * @Author: linfudong
 * @Date: 2022-03-09 17:48:40
 * @LastEditors: linfudong
 * @LastEditTime: 2022-07-11 19:13:40
 * @Description:
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base:
    process.env.CUSTOM_ENV === 'production'
      ? '/wap/lrb-zhkd-web/'
      : '/lrb-zhkd-web/',
  routes: [
    {
      path: '/',
      name: '/',
      component: () => import('@/views/index.vue'),
      meta: {
        title: '为乐付',
      },
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/views/index.vue'),
      meta: {
        title: '为乐付',
      },
    },
  ],
})

export default router
